/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory.

// To reference this file, add <%= javascript_pack_tag 'transcript_events' %> to the appropriate
// layout or = javascript_pack_tag 'transcript_events' to the appropriate haml file.

// Note: this isn't the ideal place for this logic, but putting it here
// until we convert the lesson transcript box to react.

// These functions allow the video player and transcript box to talk to each other.
// This ensures that the transcript highlighting and the video are in sync.


window.onload = function () {
  document.addEventListener(
    "tabChanged",
    () => {
      transcriptEvents()
    }
  );
  transcriptEvents()
}

function transcriptEvents () {
  const transcriptBody = document.querySelector('.transcript-body');
  let phrases = [];
  if (transcriptBody) {
    phrases = transcriptBody.querySelectorAll('.transcript-phrase');
  }

  // Enable hide/show functionality for transcript box
  const toggleButton = document.querySelector('.transcript-toggle');
  if (toggleButton && transcriptBody) {
    toggleButton.addEventListener('click', () => {
      transcriptBody.classList.toggle('full-transcript');
      if (transcriptBody.classList.contains('full-transcript')) {
        toggleButton.text = 'Hide transcript';
      } else {
        toggleButton.text = 'Read full transcript';
      }
    });
  }

  // Register a click event for each transcript phrase and let the video player know about it
  phrases.forEach(phrase => {
    phrase.addEventListener('click', () => {
      const phraseClicked = new CustomEvent('phraseClicked', { detail: { time: phrase.dataset.begin } } );
      document.dispatchEvent(phraseClicked)
    });
  });

  const compareTime = (phrase, position) => {
    return position >= phrase.dataset.begin && position <= phrase.dataset.end;
  }

  const highlightPhrase = (highlightPhrase) => {
    phrases.forEach(phrase => {
      phrase.classList.remove('active');
    });

    if (highlightPhrase) {
      highlightPhrase.classList.add('active');

      if (transcriptBody) {
        // Handle autoscrolling to make sure current phrase is in view
        const phraseHeight = highlightPhrase.offsetHeight;
        const transcriptHeight = transcriptBody.clientHeight;
        const parentTop = highlightPhrase.offsetParent.getBoundingClientRect().top;
        const top = highlightPhrase.getBoundingClientRect().top - parentTop;  // Distance from top of transcript div to top of current phrase
        const bottom = transcriptHeight - top - phraseHeight;  // Distance from bottom of current phrase to bottom of transcript div

        if (top < 0) {
          transcriptBody.scrollTop += top - 4;
        } else if (bottom < 0) {
          transcriptBody.scrollTop = transcriptBody.scrollTop - bottom - phraseHeight + transcriptHeight / 2;
        }
      }
    }
  }

  const onTime = (position) => {
    if (transcriptBody) {
      const activePhrases = transcriptBody.querySelectorAll('.active');
      let nextPhrases = [];

      for (const phrase of activePhrases) {
        nextPhrases.push(phrase.nextElementSibling);
      }

      if (activePhrases.length == 1 && compareTime(activePhrases[0], position)) {
        return; // Do nothing
      } else if (nextPhrases.length == 1 && compareTime(nextPhrases[0], position + 1)) {
        highlightPhrase(nextPhrases[0]);
      } else {
        // Search for the phrase to highlight
        phrases.forEach(phrase => {
          if (compareTime(phrase, position)) {
            highlightPhrase(phrase);
          }
        });
      }
    }
  };

  // Listen for a change in player time location and update phrase highlight if needed
  document.addEventListener('timeUpdate', (e) => {
    onTime(e.detail.time);
  })
}
